import signin from '../signin'

const getLeadUsingHubInfo = (
  lead_uuid,
  hubToken,
  origin,
  sourceUrlBase64,
  isEmailMarketingHub
) => {
  const url = isEmailMarketingHub
    ? `/lead/remarketing/`
    : `/get_lead?lead_uuid=${lead_uuid}&token=${hubToken}&origin=${origin}&source_url=${sourceUrlBase64}`

  return signin('hub')
    .then(({ http }) => {
      isEmailMarketingHub
        ? (http.defaults.headers['Token'] = `Bearer ${hubToken}`)
        : null
      return http
        .get(url)
        .then((res) => {
          return res
        })
        .catch((e) => {
          console.error('error using getLeadUsingHubInfo', e)
        })
    })
    .catch((error) => {
      console.error('getHubInfo error -', error)
      throw error
    })
}

const getMarketplaceUrls = (token) => {
  return signin('hub').then(({ http }) => {
    http.defaults.headers['Token'] = `Bearer ${token}`
    return http
      .get(`/send_skip/`)
      .then((res) => {
        return res
      })
      .catch((e) => {
        console.error('error using getMarketplaceUrls', e)
      })
  })
}

export default { getLeadUsingHubInfo, getMarketplaceUrls }
